module.exports = __webpack_public_path__ + "static/media/kalkulator inwestycyjny.d1c0422e.jpg";